(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motions = new WeakMap();
  // Capture the current frame before cancelling, so interrupted motion never jumps.
  function move(element, target, { from, duration = 240, delay = 0 } = {}) {
    if (!element) return Promise.resolve();
    const current = getComputedStyle(element);
    const start = from || Object.fromEntries(Object.keys(target).map(key => [key, current[key]]));
    motions.get(element)?.cancel();
    Object.assign(element.style, target);
    if (reduced.matches) return Promise.resolve();
    const animation = element.animate([start, target], { duration, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
    motions.set(element, animation);
    return animation.finished.catch(() => {}).then(() => {
      if (motions.get(element) === animation) motions.delete(element);
    });
  }
  let searchVersion = 0;
  function setSearch(open) {
    const searchPanel = document.querySelector('[data-mh-search-panel]');
    const searchToggle = document.querySelector('[data-mh-search-toggle]');
    if (!searchPanel || !searchToggle) return;
    if (open === (searchToggle.getAttribute('aria-expanded') === 'true') && (open || (searchPanel.hidden && !document.body.matches('.mh-search-open,.mh-search-transition')))) return;
    const version = ++searchVersion;
    const wasHidden = searchPanel.hidden;
    const glyph = searchPanel.querySelector('.mh-search-form > svg');
    const triggerBox = searchToggle.querySelector('svg').getBoundingClientRect();
    searchPanel.hidden = false;
    searchPanel.classList.add('is-open');
    searchPanel.inert = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
    document.body.classList.add('mh-search-transition');
    document.body.classList.toggle('mh-search-open', open);
    for (const child of searchPanel.parentElement.children) {
      if (child !== searchPanel) child.inert = open;
    }
    // Layout position excludes an in-flight transform; the target remains stable on reversal.
    const form = searchPanel.querySelector('form');
    const formBox = form.getBoundingClientRect();
    const glyphX = formBox.left + parseFloat(getComputedStyle(form).paddingLeft);
    const glyphY = formBox.top + (formBox.height - glyph.getBoundingClientRect().height) / 2;
    const atTrigger = `translate(${triggerBox.left - glyphX}px, ${triggerBox.top - glyphY}px)`;
    const travel = move(glyph, { transform: open ? 'translate(0px, 0px)' : atTrigger }, {
      from: wasHidden ? { transform: atTrigger } : undefined,
      duration: open ? 280 : 220
    });
    for (const element of [searchPanel.querySelector('input'), searchPanel.querySelector('[data-mh-search-close]'), searchPanel.querySelector('[data-mh-search-results]')]) {
      move(element, { opacity: open ? '1' : '0', transform: open ? 'translateY(0px)' : 'translateY(6px)' }, {
        from: wasHidden ? { opacity: '0', transform: 'translateY(6px)' } : undefined,
        duration: open ? 180 : 120, delay: open && wasHidden ? 70 : 0
      });
    }
    if (open) {
      document.body.classList.remove('mh-header-hidden');
      document.querySelectorAll('.mh-desktop-nav .mh-mega-group[open]').forEach(group => setMenu(group, false));
      searchPanel.querySelector('input').focus({ preventScroll: true });
      searchPanel.querySelector('input').dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      document.dispatchEvent(new Event('mh:search-close'));
    }
    const finish = () => {
      if (version !== searchVersion) return;
      document.body.classList.remove('mh-search-transition');
      if (!open) { searchPanel.hidden = true; searchPanel.classList.remove('is-open'); }
    };
    if (reduced.matches) finish(); else travel.then(finish);
  }
  document.addEventListener('click', e => {
    const panel = document.querySelector('[data-mh-search-panel]');
    if (e.target.closest('[data-mh-search-toggle]')) { setSearch(e.target.closest('[data-mh-search-toggle]').getAttribute('aria-expanded') !== 'true'); return; }
    if (e.target.closest('[data-mh-search-close]')) { setSearch(false); document.querySelector('[data-mh-search-toggle]')?.focus(); return; }
    if (panel && !panel.hidden && !e.target.closest('[data-mh-search-panel]')) setSearch(false);
  });
  document.addEventListener('keydown', e => {
    const searchPanel = document.querySelector('[data-mh-search-panel]');
    if (!searchPanel || searchPanel.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); setSearch(false); document.querySelector('[data-mh-search-toggle]')?.focus(); }
    if (e.key === 'ArrowDown' && e.target.id === 'mh-search-input') { const link = searchPanel.querySelector('.mh-search-result'); if (link) { e.preventDefault(); link.focus(); } }
  });
  const dialogTriggers = new WeakMap();
  const initializedDialogs = new WeakSet();
  const initializedCarousels = new WeakSet();
  function closeDialog(dialog) {
    if (!dialog?.open) return;
    dialog.close();
  }
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    document.querySelectorAll('.mh-dialog[open]').forEach(other => other.close());
    if (trigger) dialogTriggers.set(dialog, trigger);
    dialog.showModal();
    if (dialog.matches('.mh-look-dialog:not(.mh-quick-dialog)')) {
      dialog.scrollTop = 0;
      const content = dialog.querySelector('.mh-look-content');
      if (content) content.scrollTop = 0;
    }
    document.documentElement.style.overflow = 'hidden';
    if (dialog.id === 'mh-search') dialog.querySelector('input[type=search]')?.focus();
    document.dispatchEvent(new CustomEvent('mh:dialog-open', { detail: { dialog } }));
  }
  function syncSalePrice(root, data) {
    const prices = root.querySelector('[data-mh-prices]');
    if (!prices) return;
    const current = Number(data?.priceCents), compare = Number(data?.compareCents);
    const sale = data?.priceCents !== undefined && Number.isFinite(current) && current >= 0 && Number.isFinite(compare) && compare > current && compare > 0;
    prices.toggleAttribute('data-sale', sale);
    const previous = prices.querySelector('[data-mh-compare-price]');
    const badge = prices.querySelector('[data-mh-discount]');
    previous.hidden = !sale;
    previous.textContent = sale ? data.comparePrice : '';
    badge.hidden = !sale;
    badge.textContent = sale ? '−' + Math.floor((compare - current) * 100 / compare) + '%' : '';
  }
  window.MarbilyUI = { openDialog, closeDialog, syncSalePrice };
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-mh-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.mhOpen);
      if (!dialog) return;
      event.preventDefault();
      openDialog(dialog, open);
    }
    const close = event.target.closest('[data-mh-close]');
    if (close) {
      closeDialog(close.closest('dialog'));
      const desktopGroup = close.closest('.mh-desktop-nav .mh-mega-group');
      if (desktopGroup) {
        setMenu(desktopGroup, false);
        const destination = close.matches('.mh-nav-configurator') && document.getElementById('mh-configurator');
        if (destination) {
          // Keep preview/campaign parameters when this is an in-page link.
          event.preventDefault();
          window.location.hash = 'mh-configurator';
          destination.setAttribute('tabindex', '-1');
          destination.focus({ preventScroll: true });
          destination.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
        }
      }
    }
    const swatch = event.target.closest('[data-mh-variant]');
    if (swatch) {
      const card = swatch.closest('[data-mh-product]');
      card.querySelectorAll('[data-mh-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === swatch)));
      card.querySelectorAll('[data-mh-product-link]').forEach(link => link.href = swatch.dataset.url);
      card.querySelector('[data-mh-price]').textContent = swatch.dataset.price;
      syncSalePrice(card, swatch.dataset);
      const addForm = card.querySelector('[data-mh-card-add]');
      if (addForm) {
        addForm.elements.id.value = swatch.dataset.mhVariant;
        addForm.dataset.available = swatch.dataset.available;
        const available = swatch.dataset.available === 'true';
        addForm.querySelector('button[type=submit]').disabled = !available || addForm.getAttribute('aria-busy') === 'true';
        addForm.querySelector('[data-mh-add-label]').textContent = available ? 'Dodaj do koszyka' : 'Wariant wyprzedany';
        if (addForm.getAttribute('aria-busy') !== 'true') addForm.querySelector('[data-mh-form-status]').textContent = '';
      }
      const title = card.querySelector('[data-mh-card-title]');
      if (title && swatch.dataset.title) title.textContent = swatch.dataset.title;
      const img = card.querySelector('.mh-card-image');
      if (img) {
        img.hidden = !swatch.dataset.image;
        img.removeAttribute('srcset');
        if (swatch.dataset.image) img.src = swatch.dataset.image; else img.removeAttribute('src');
        img.alt = swatch.getAttribute('aria-label');
      }
      const missing = card.querySelector('[data-mh-missing-photo]');
      if (missing) missing.hidden = Boolean(swatch.dataset.image);
      const hover = card.querySelector('.mh-card-hover');
      if (hover) { hover.hidden = !swatch.dataset.hoverImage; if (swatch.dataset.hoverImage) { hover.src = swatch.dataset.hoverImage; hover.alt = swatch.getAttribute('aria-label'); } }
      const quick = document.getElementById(card.querySelector('[data-mh-open]')?.dataset.mhOpen);
      const select = quick?.querySelector('[data-mh-look-variant]');
      if (select) { select.value = swatch.dataset.mhVariant; select.dispatchEvent(new Event('change', {bubbles:true})); }
      card.querySelector('[data-mh-variant-status]').textContent = 'Wybrano: ' + swatch.getAttribute('aria-label');
    }
  });
  document.addEventListener('pointerover', event => {
    const photo = event.target.closest('.mh-product-image')?.querySelector('.mh-card-hover');
    if (photo?.getAttribute('src')) photo.loading = 'eager';
  }, {passive:true});
  function initDialogs(root = document) { root.querySelectorAll('.mh-dialog').forEach(dialog => {
    if (initializedDialogs.has(dialog)) return;
    initializedDialogs.add(dialog);
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) closeDialog(dialog);
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('.mh-dialog[open]')) {
        document.documentElement.style.overflow = '';
        const trigger = dialogTriggers.get(dialog);
        if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      }
    });
  }); }
  initDialogs();
  function initCarousels(root = document) {
    root.querySelectorAll('[data-mh-carousel]').forEach(section => {
      if (initializedCarousels.has(section)) return;
      initializedCarousels.add(section);
      const track = section.querySelector('[data-mh-track]');
      const prev = section.querySelector('[data-mh-prev]'), next = section.querySelector('[data-mh-next]');
      if (!track || !prev || !next) return;
      const sync = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3; };
      [prev,next].forEach((button,index) => button.addEventListener('click', () => {
        track.scrollBy({ left: (index ? 1 : -1) * ((track.firstElementChild?.getBoundingClientRect().width || 250) + parseFloat(getComputedStyle(track).gap)), behavior: reduced.matches ? 'instant' : 'smooth' });
      }));
      track.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(track);
      sync();
    });
  }
  initCarousels();
  const initializedMenus = new WeakSet();
  const menuStates = new WeakMap();
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  function setMenu(group, open) {
    const panel = group.querySelector('.mh-mega-panel');
    const summary = group.querySelector('summary');
    if (!panel || !summary) { group.open = open; return; }
    const state = menuStates.get(group) || { open: group.open, version: 0 };
    menuStates.set(group, state);
    clearTimeout(state.timer);
    if (state.open === open) return;
    const wasClosed = !group.open;
    state.open = open;
    const version = ++state.version;
    summary.setAttribute('aria-expanded', String(open));
    group.classList.toggle('mh-menu-closing', !open);
    panel.inert = !open;
    if (open) {
      group.parentElement.querySelectorAll('.mh-mega-group[open]').forEach(other => {
        if (other !== group) setMenu(other, false);
      });
      group.open = true;
      const trigger = summary.getBoundingClientRect(), box = panel.getBoundingClientRect();
      panel.style.transformOrigin = `${trigger.left + trigger.width / 2 - box.left}px 0px`;
    }
    const completion = move(panel, { opacity: open ? '1' : '0', transform: open ? 'translateY(0px) scale(1)' : 'translateY(-6px) scale(.985)' }, {
      from: wasClosed ? { opacity: '0', transform: 'translateY(-8px) scale(.975)' } : undefined,
      duration: open ? 240 : 160
    });
    const finish = () => {
      if (version !== state.version) return;
      if (!open) { group.open = false; group.classList.remove('mh-menu-closing'); }
    };
    if (reduced.matches) finish(); else completion.then(finish);
  }
  function initMenus(root = document) {
    root.querySelectorAll('.mh-mega-group').forEach(group => {
      if (initializedMenus.has(group)) return;
      initializedMenus.add(group);
      if (group.closest('.mh-desktop-nav')) {
        const state = { open: group.open, version: 0 };
        menuStates.set(group, state);
        group.querySelector('summary').addEventListener('click', event => { event.preventDefault(); setMenu(group, !state.open); });
        group.addEventListener('pointerenter', () => { if (finePointer.matches) setMenu(group, true); });
        group.addEventListener('pointerleave', () => { if (finePointer.matches) state.timer = setTimeout(() => setMenu(group, false), 140); });
        group.addEventListener('focusout', () => setTimeout(() => { if (!group.contains(document.activeElement)) setMenu(group, false); }, 0));
      } else {
        group.addEventListener('toggle', () => {
          if (group.open) group.parentElement.querySelectorAll('.mh-mega-group[open]').forEach(other => { if (other !== group) other.open = false; });
        });
      }
    });
  }
  initMenus();
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented) return;
    if (event.key === 'Escape' && document.querySelector('.mh-dialog[open]')) { event.preventDefault(); closeDialog(document.querySelector('.mh-dialog[open]')); return; }
    if (event.key === 'Escape') document.querySelectorAll('.mh-desktop-nav .mh-mega-group[open]:not(.mh-menu-closing)').forEach(group => { setMenu(group, false); group.querySelector('summary').focus({ preventScroll: true }); });
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.mh-mega-group')) document.querySelectorAll('.mh-desktop-nav .mh-mega-group[open]').forEach(group => setMenu(group, false));
  });
  document.addEventListener('mh:content-loaded', event => {
    initCarousels(event.target);
    initDialogs(event.target);
    event.target.querySelectorAll('[data-mh-track]').forEach(track => track.dispatchEvent(new Event('scroll')));
  });
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-mh-search-panel]')) setSearch(false);
    initCarousels(event.target);
    initDialogs(event.target);
    initMenus(event.target);
    event.target.querySelectorAll('.mh-footer-wordmark').forEach(el => el.classList.add('mh-visible'));
    adaptFooter();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('.mh-dialog[open]')) document.documentElement.style.overflow = '';
  });
  if (!reduced.matches && 'IntersectionObserver' in window) {
    document.body.classList.add('mh-motion');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('mh-visible'); observer.unobserve(entry.target); }
    }), { threshold: .12 });
    document.querySelectorAll('.mh-footer-wordmark').forEach(el => observer.observe(el));
  }
  const mobile = matchMedia('(max-width: 700px)');
  const adaptFooter = () => document.querySelectorAll('.mh-footer-links').forEach(details => details.open = !mobile.matches);
  adaptFooter(); mobile.addEventListener('change', adaptFooter);
  let ticking = false, lastScroll = Math.max(0, scrollY), direction = 0, travel = 0;
  document.addEventListener('focusin', event => { if (event.target.closest('[data-mh-header]')) document.body.classList.remove('mh-header-hidden'); });
  document.addEventListener('mh:dialog-open', () => document.body.classList.remove('mh-header-hidden'));
  const syncDock = () => {
    document.body.classList.toggle('mh-dock-visible', scrollY > 420);
    const y = Math.max(0, scrollY), delta = y - lastScroll, nextDirection = Math.sign(delta);
    if (nextDirection && nextDirection !== direction) { direction = nextDirection; travel = 0; }
    travel += Math.abs(delta); lastScroll = y;
    const header = document.querySelector('[data-mh-header]');
    const engaged = header?.contains(document.activeElement) || document.querySelector('.mh-desktop-nav details[open], .mh-dialog[open]');
    if (y < 160 || engaged) document.body.classList.remove('mh-header-hidden');
    else if (travel > 36) document.body.classList.toggle('mh-header-hidden', direction > 0);
    ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(syncDock); } }, { passive: true });
  reduced.addEventListener('change', syncDock);
  syncDock();
})();
